import { useState } from "react";

import styles from "./date-range-picker.module.css";

export const getDateRange = dateRangeConfig => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    let start = new Date(now.getTime());;
    let end = new Date(now.getTime());;

    switch (dateRangeConfig.option) {
        case "last7days":
            start.setDate(now.getDate() - 7);
            break;
        case "last4weeks":
            start.setDate(now.getDate() - 7 * 4);
            break;
        case "last3months":
            start.setDate(now.getDate() - 30 * 3);
            break;
        case "last12months":
            start.setDate(now.getDate() - 365);
            break;
        case "alltime":
            start = null;
            end = null;
            break;
        case "custom":
            start = dateRangeConfig.start;
            end = dateRangeConfig.end;
            break;
        default:
            throw new Error(dateRangeConfig.option);
    }

    return { start, end };
}

export default ({ dateRangeConfig, onDateRangeConfigChange }) => {
    const renderTimeRangeOption = (label, delta) => (
        <li>
            <label>
                <input
                    type="checkbox"
                    checked={dateRangeConfig.option === delta.option}
                    onChange={() => onDateRangeConfigChange({
                        ...dateRangeConfig,
                        ...delta
                    })}
                />
                <span>{label}</span>
            </label>
        </li>
    );
    const handleCustomDateChange = (field, value) => {
        const parsedValue = new Date(value);
        const parsed = !isNaN(parsedValue.getTime());
        if(parsed) {
            onDateRangeConfigChange({
                ...dateRangeConfig,
                [field]: parsedValue,
            });
        }
    };
    return (
        <div className={styles.root}>
            <ul>
                {renderTimeRangeOption("Last 7 days", { option: "last7days" })}
                {renderTimeRangeOption("Last 4 weeks", { option: "last4weeks" })}
                {renderTimeRangeOption("Last 3 months", { option: "last3months" })}
                {renderTimeRangeOption("Last 12 months", { option: "last12months" })}
                {renderTimeRangeOption("All time", { option: "alltime" })}
                {renderTimeRangeOption("Custom", {
                    option: "custom",
                    ...getDateRange(
                        dateRangeConfig.option !== "alltime"
                        ? dateRangeConfig : { option: "last3months" }
                    )
                })}
            </ul>
            { dateRangeConfig.option === "custom" &&
                <div className={styles.customDatePicker}>
                    <label>
                        <span>From</span>
                        <input
                            type="date"
                            value={dateRangeConfig.start.toISOString().split("T")[0]}
                            onChange={e => handleCustomDateChange("start", e.target.value)}
                        />
                    </label>
                    <label>
                        <span>Until</span>
                        <input
                            type="date"
                            value={dateRangeConfig.end.toISOString().split("T")[0]}
                            onChange={e => handleCustomDateChange("end", e.target.value)}
                        />
                    </label>
                    { dateRangeConfig.end < dateRangeConfig.start && <p>Start date must be before end date</p> }
                </div>
            }
        </div>
    );
};
